import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, SEMANTIC_TEXT_PX, TITLE_FONT_COLOR, DISABLED_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const FilterLabel = styled.span`
    font-weight: 600;
    font-size: 16px;
    color: #333;
`;

export const FilterContent = styled.div`
    display: flex;
    flex-direction: column;
    ${scrollBarStyle}
    flex: 1;
    min-height: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #f5f5f5;
    gap: 0;
    padding: 0;
    padding-top:2px;
    ${media.mobileDevice`
       padding-bottom: calc(50dvh + env(safe-area-inset-bottom));
    `}
    @media only screen and (min-height: 800px) and (max-width: 430px) {
        padding-bottom: 250px;
    }
`;

export const SurgeryDateRangeWrapper = styled.div`
    /* indent the Start/End date row so it lines up with the filter headers */
    div[style*='display: flex'] {
        padding-left: 28px;
        padding-right: 19px;
    }
    /* override the inner date box width (default 75%) so the pickers
       fill their column and remove the wide empty gap between them */
    div[style*='width: 100%'] > div:nth-child(2) {
        width: 100% !important;
    }
    /* reduce the gap between the date row and the Set as Default button */
    & > div > div:nth-last-child(2) {
        margin-bottom: 0px !important;
    }
`;

export const FilterFooter = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 1rem 14px;
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    height: 10%;
    border-top: 1px solid #e0e0e0;

     /* Keep full-screen treatment for short landscape phone viewports only.
         iPad landscape should stay anchored as a popup. */
     @media screen and (orientation: landscape) and (pointer: coarse) and (max-height: 576px) {
        height: 20%;
    }
`;


export const Reset = styled.p`
    color: ${({ disabled }) => disabled ? DISABLED_FONT_COLOR : TITLE_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
    padding-right: 1.3em;
    align-self: center;
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
    opacity: ${({ disabled }) => disabled ? 0.5 : 1};
    &:hover {
        cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    }
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 16px;
    margin-top: 11px;
    margin-right: 16px;
    margin-bottom: 7px;
    ${media.mobileDevice`
        margin-bottom: 25px;
    `}
`;
export const FilterHeading = styled.p`
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: 24px;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
    letter-spacing: 0;
`;

export const FilterPopup = styled.div.attrs({ 'data-filter-popup': '' })`
    position: absolute;
    top: calc(100% + 8px);
    right: -5px;
    z-index: 1000;
    background: #f5f5f5;
    box-shadow: 0px 0px 6px #00000029;
    width: 390px;
    height: ${({ bannerHeight }) => bannerHeight ? `calc(78vh - ${bannerHeight})` : '78vh'};
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;
    padding: 0;
    gap: 0;

    ${media.mediumDevice`
        width: 360px;
    `}

    ${media.mobileDevice`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        width: 100vw;
        min-width: 100vw;
        max-width: none;
		height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'} !important;
        border-radius: 0;
        padding-bottom: ${({ bannerHeight }) => bannerHeight ? '0px' : '80px'};
        z-index: 200000;
    `}

    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
        position: fixed;
        top: 0;
        left: 0;
        right: auto;
        bottom: 0;
        width: 100vw !important;
        min-width: 100vw;
        max-width: none !important;
        height: 100vh !important;
        height: 100dvh !important;
        border-radius: 0;
        padding-bottom: 0;
        z-index: 200000;
    }
`;

export const FilterComponentHeaderFooter = styled.div`
    background: #ffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 28px;
    padding-right: 19px;
    padding-top: 18px;
    padding-bottom: 20px;
    border-radius: 6px;
    align-items: center;
    cursor: pointer;
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
    font-size: 15px;
`;
